import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { getSetting, login, setMobile, setToken } from "../../services";
import { useFormik } from "formik";
import { initialValues, validationSchema } from "../../utils/formsValidator/loginFormValidator";
import { useAuthAction } from "../../context/AuthContext";
import { pushToast } from "../../utils/pushToast";
import Loading from "../../components/Loading";
import Input from "../../components/Input";
import InputPassword from "../../components/InputPassword";
import { convertToWesternNumerals } from "../../utils/helper";
import { useSweetAlert } from "../../context/sweetAlertContext";

export default function Login() {
    const sweetAlert = useSweetAlert();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [searchParams, setSearchParams] = useSearchParams();
    const [activeRegisterationInApplication, setActiveRegisterationInApplication] = useState(false);
    const [deActiveRegisterationInApplicationMessage, setDeActiveRegisterationInApplicationMessage] = useState("");
    const { setUser } = useAuthAction();

    const loadSetting = async () => {
        try {
            const { data } = await getSetting();

            setActiveRegisterationInApplication(data.activeRegisterationInApplication);
            setDeActiveRegisterationInApplicationMessage(data.deActiveRegisterationInApplicationMessage);

            const isAdminBypass = searchParams.get("admin") === "true";

            // ✅ اگر سایت بسته است و لینک ادمین نیست → برو به coming soon
            if (!data.activeApplication && !isAdminBypass) {
                navigate("/coming-soon");
                return;
            }

            // ✅ اگر قبلاً لاگین بوده
            if (data.currentUserId) {
                navigate("/");
            } else {
                setIsLoading(false);
            }

        } catch (ex) {
            setIsLoading(false);
        }
    }


    useEffect(() => {
        setIsLoading(true);
        const dataParam = searchParams.get('data');
        if (dataParam !== "activateTrue") {
            loadSetting();
        } else {
            setIsLoading(false);
        }
    }, []);

    const onSubmit = async (values) => {
        setIsLoading(true);
        try {
            const { userInfo, userPermission, message, status } = await login(values);

            if (status === 201) {
                console.log(message)
                pushToast(message, "error")
                setIsLoading(false);

            } else {

                if (userInfo.isSuccess) {
                    setMobile(userInfo.data.mobile);
                    setToken(userInfo?.data?.token)
                    setUser({ userInfo: userInfo, userPermission });
                    const searchParams = new URLSearchParams(window.location.search);

                    // Check if the "redirect" parameter exists
                    const hasRedirectParameter = searchParams.has('redirect');
                    if (hasRedirectParameter) {
                        const queryString = window.location.search;

                        // Extract the value associated with the "redirect" parameter
                        const redirectValue = queryString.split('redirect=')[1];

                        navigate(redirectValue);
                    } else {
                        if (userPermission.some(x => x === "UserDashboard"))
                            navigate('/dashboard');
                        else {
                            navigate('/dashboard');
                        }
                    }
                } else {

                    pushToast(message, "error")
                }
            }
            setIsLoading(false);
        } catch (e) {

            console.log(e);

            if (navigator.onLine) {
                navigate("/coming-soon")

            } else {
                pushToast("اینترنت خود را بررسی کنید", "error")
            }
            setIsLoading(false);
        }
    }

    const formik = useFormik({
        initialValues,
        onSubmit,
        validationSchema,
        validateOnMount: false,
        validateOnChange: true
    });

    /*
    const ecunionImage = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQwIiBoZWlnaHQ9IjM2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KCTxwYXRoIGQ9Im0xMjAgMjQzbDk0LTU0IDAtMTA5IC05NCA1NCAwIDEwOSAwIDB6IiBmaWxsPSIjODA4Mjg1Ii8+Cgk8cGF0aCBkPSJtMTIwIDI1NGwtMTAzLTYwIDAtMTE5IDEwMy02MCAxMDMgNjAgMCAxMTkgLTEwMyA2MHoiIHN0eWxlPSJmaWxsOm5vbmU7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS13aWR0aDo1O3N0cm9rZTojMDBhZWVmIi8+Cgk8cGF0aCBkPSJtMjE0IDgwbC05NC01NCAtOTQgNTQgOTQgNTQgOTQtNTR6IiBmaWxsPSIjMDBhZWVmIi8+Cgk8cGF0aCBkPSJtMjYgODBsMCAxMDkgOTQgNTQgMC0xMDkgLTk0LTU0IDAgMHoiIGZpbGw9IiM1ODU5NWIiLz4KCTxwYXRoIGQ9Im0xMjAgMTU3bDQ3LTI3IDAtMjMgLTQ3LTI3IC00NyAyNyAwIDU0IDQ3IDI3IDQ3LTI3IiBzdHlsZT0iZmlsbDpub25lO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1zaW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6MTU7c3Ryb2tlOiNmZmYiLz4KCTx0ZXh0IHg9IjE1IiB5PSIzMDAiIGZvbnQtc2l6ZT0iMjVweCIgZm9udC1mYW1pbHk9IidCIFlla2FuJyIgc3R5bGU9ImZpbGw6IzI5Mjk1Mjtmb250LXdlaWdodDpib2xkIj7Yudi22Ygg2KfYqtit2KfYr9uM2Ycg2qnYtNmI2LHbjDwvdGV4dD4KCTx0ZXh0IHg9IjgiIHk9IjM0MyIgZm9udC1zaXplPSIyNXB4IiBmb250LWZhbWlseT0iJ0IgWWVrYW4nIiBzdHlsZT0iZmlsbDojMjkyOTUyO2ZvbnQtd2VpZ2h0OmJvbGQiPtqp2LPYqCDZiCDaqdin2LHZh9in24wg2YXYrNin2LLbjDwvdGV4dD4KPC9zdmc+ "
    const handleClickEcunion = () => {
        window.open('https://ecunion.ir/verify/karsood.irsecret-2ec90950', 'Popup', 'toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=580, height=600, top=30');
    }
    */

    return (
        <>
            {isLoading ? <Loading /> :
                <div className="backgroud-image">
                    <div className="authentication-wrapper authentication-basic container-p-y">
                        <div className="authentication-inner py-4">
                            <div className="card card-border">
                                <div className="card-body">
                                    <div className="col-5 app-brand justify-content-center m-auto">
                                        {/*<img src="/logo.png" className={'w-100 '}/>*/}
                                    </div>
                                    <hr />
                                    <h4 className="mb-2 text-center ">ورود</h4>

                                    <form id="formAuthentication"
                                        className={`needs-validation mb-3 ${!formik.isValid ? "was-validated" : ""}`}
                                        noValidate={true} onSubmit={formik.handleSubmit}
                                        autoComplete="off"
                                    >
                                        <div className="mb-3 position-relative">
                                            <label><div style={{ fontWeight: 'bold', display: 'inline-block', fontSize: '16px', color: 'black' }} >نام کاربری:</div> شماره همراه، کد دعوت، ایمیل</label>
                                            <Input
                                                type="text"
                                                className="text-start"
                                                dir="ltr"
                                                name="mobile"
                                                placeholder="یکی از موارد بالا را وارد نمایید"
                                                autoComplete="off"
                                                // label="نام کاربری: شماره همراه، کد دعوت، ایمیل"
                                                formik={formik}
                                                icon={'bx-mobile'}
                                                value={convertToWesternNumerals(formik.values.mobile)} // Use formik.values directly
                                                onChange={(e) => {
                                                    const convertedValue = convertToWesternNumerals(e.target.value);
                                                    formik.handleChange(e);
                                                    formik.setFieldValue('mobile', convertedValue);
                                                }}

                                            />
                                        </div>

                                        <div className="mb-3 form-password-toggle">
                                            <InputPassword
                                                className="text-start"
                                                dir="ltr"
                                                name="password"
                                                placeholder="..........."
                                                formik={formik}
                                                label="رمز عبور"
                                                value={convertToWesternNumerals(formik.values.password)} // Use formik.values directly
                                                onChange={(e) => {
                                                    const convertedValue = convertToWesternNumerals(e.target.value);
                                                    formik.handleChange(e);
                                                    formik.setFieldValue('password', convertedValue);
                                                }}
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <button className="btn btn-primary d-grid w-100" type="submit"
                                            >ورود
                                                {
                                                    isLoading && <Loading />
                                                }
                                            </button>

                                        </div>
                                        {activeRegisterationInApplication &&
                                            <Link to="/register">
                                                <p className="text-center border-red">
                                                    <span>حساب کاربری ندارید؟</span><span>&nbsp;</span>

                                                    <span className={"color-animation2"}>ثبت نام کنید</span>

                                                </p>
                                            </Link>}
                                        {!activeRegisterationInApplication &&
                                            <p className="text-center border-red">
                                                {deActiveRegisterationInApplicationMessage}
                                            </p>
                                        }
                                        <p className="text-center">
                                            رمز ورودتان را فراموش کرده اید؟
                                            <Link to="/forget-password">
                                                <span>  بازیابی رمز عبور</span>
                                            </Link>
                                        </p>
                                    </form>
                                    {/*<CacheClearButton/>*/}

                                    {/* لینک به صفحه مجوزها به‌جای لوگوها */}
                                    <div className="text-center mt-3 pt-2 border-top">
                                        <Link 
                                            to="/cert" 
                                            style={{ textDecoration: 'underline' }}
                                            className="text-primary fw-bold"
                                        >
                                            مشاهده مجوزها 
                                        </Link>
                                    </div>

                                    {/* 
                                    <div className={"row"}>
                                        <div className={"col-4 mb-2"}>
                                            <a target='_blank' href="https://logo.samandehi.ir/Verify.aspx?id=367417&p=xlaogvkajyoeaodsrfthjyoe">
                                                <img referrerPolicy='origin' id='rgvjfukzjzpewlaojxlzjzpe' className={"img-fluid"}
                                                    alt=''
                                                    src='https://logo.samandehi.ir/logo.aspx?id=367417&p=qftiwlbqyndtshwlnbpdyndt' />
                                            </a>
                                        </div>

                                        <div className={"col-4 mb-2"} >
                                            <img onClick={handleClickEcunion} src={ecunionImage}
                                                style={{ cursor: "pointer", width: "96px", height: "113px" }} />
                                        </div>

                                        <div className={"col-4 mb-2"}>
                                            <a referrerPolicy='origin' target='_blank'
                                                href='https://trustseal.enamad.ir/?id=455421&Code=GAPGPTMASKTOKENsarq2t4l9zeX0X'>
                                                <img className={"img-fluid"} referrerPolicy='origin' src='https://trustseal.enamad.ir/logo.aspx?id=455421&Code=GAPGPTMASKTOKENsarq2t4l9zeX1X' alt='' code='GAPGPTMASKTOKENsarq2t4l9zeX2X' /></a>
                                        </div>
                                    </div> 
                                    */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}
        </>
    );
}
